(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["march-sale-2023"] && !Shopify.designMode) return;
  try {
    

    const desktopHero = document.getElementById('desktop-hero'),
          mobileHero = document.getElementById('mobile-hero');

    const desktopIframeContent = `
      <!DOCTYPE html>
      <!--
      	NOTES:
      	1. All tokens are represented by '$' sign in the template.
      	2. You can write your code only wherever mentioned.
      	3. All occurrences of existing tokens will be replaced by their appropriate values.
      	4. Blank lines will be removed automatically.
      	5. Remove unnecessary comments before creating your template.
      -->
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="authoring-tool" content="Adobe_Animate_CC">
      <title>March30OffSale_AudiolabWharfedaleDual_AVR_1800x800px_Html5</title>
      <!-- write your code here -->
      <script src="https://code.createjs.com/1.0.0/createjs.min.js"></script>
      <script src="${desktopScriptURI}"></script>
      <script>
      var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;
      function init() {
      	canvas = document.getElementById("canvas");
      	anim_container = document.getElementById("animation_container");
      	dom_overlay_container = document.getElementById("dom_overlay_container");
      	var comp=AdobeAn.getComposition("51337532DCD90D4E8C3F16CDDA2EC457");
      	var lib=comp.getLibrary();
      	var loader = new createjs.LoadQueue(false);
      	loader.addEventListener("fileload", function(evt){handleFileLoad(evt,comp)});
      	loader.addEventListener("complete", function(evt){handleComplete(evt,comp)});
      	var lib=comp.getLibrary();
      	loader.loadManifest(lib.properties.manifest);
      }
      function handleFileLoad(evt, comp) {
      	var images=comp.getImages();	
      	if (evt && (evt.item.type == "image")) { images[evt.item.id] = evt.result; }	
      }
      function handleComplete(evt,comp) {
      	//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
      	var lib=comp.getLibrary();
      	var ss=comp.getSpriteSheet();
      	var queue = evt.target;
      	var ssMetadata = lib.ssMetadata;
      	for(i=0; i<ssMetadata.length; i++) {
      		ss[ssMetadata[i].name] = new createjs.SpriteSheet( {"images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames} )
      	}
      	exportRoot = new lib.March30OffSale_AudiolabWharfedaleDual_AVR_1800x800px_Html5();
      	stage = new lib.Stage(canvas);
      	stage.enableMouseOver();	
      	//Registers the "tick" event listener.
      	fnStartAnimation = function() {
      		stage.addChild(exportRoot);
      		createjs.Ticker.framerate = lib.properties.fps;
      		createjs.Ticker.addEventListener("tick", stage);
      	}	    
      	//Code to support hidpi screens and responsive scaling.
      	AdobeAn.makeResponsive(true,'both',true,1,[canvas,anim_container,dom_overlay_container]);	
      	AdobeAn.compositionLoaded(lib.properties.id);
      	fnStartAnimation();
      }
      </script>
      <!-- write your code here -->
      </head>
      <body onload="init();" style="margin:0px;">
      	<div id="animation_container" style="background-color:rgba(0, 0, 0, 1.00); width:1800px; height:800px">
      		<canvas id="canvas" width="1800" height="800" style="position: absolute; display: block; background-color:rgba(0, 0, 0, 1.00);"></canvas>
      		<div id="dom_overlay_container" style="pointer-events:none; overflow:hidden; width:1800px; height:800px; position: absolute; left: 0px; top: 0px; display: block;">
      		</div>
      	</div>
      </body>
      </html>
    `;

    const mobileIframeContent = `
      <!DOCTYPE html>
      <!--
      	NOTES:
      	1. All tokens are represented by '$' sign in the template.
      	2. You can write your code only wherever mentioned.
      	3. All occurrences of existing tokens will be replaced by their appropriate values.
      	4. Blank lines will be removed automatically.
      	5. Remove unnecessary comments before creating your template.
      -->
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="authoring-tool" content="Adobe_Animate_CC">
      <title>March30OffSale_AudiolabWharfedaleDual_AVR_750x1100px_Html5</title>
      <!-- write your code here -->
      <script src="https://code.createjs.com/1.0.0/createjs.min.js"></script>
      <script src="${mobileScriptURI}"></script>
      <script>
      var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;
      function init() {
      	canvas = document.getElementById("canvas");
      	anim_container = document.getElementById("animation_container");
      	dom_overlay_container = document.getElementById("dom_overlay_container");
      	var comp=AdobeAn.getComposition("51337532DCD90D4E8C3F16CDDA2EC457");
      	var lib=comp.getLibrary();
      	var loader = new createjs.LoadQueue(false);
      	loader.addEventListener("fileload", function(evt){handleFileLoad(evt,comp)});
      	loader.addEventListener("complete", function(evt){handleComplete(evt,comp)});
      	var lib=comp.getLibrary();
      	loader.loadManifest(lib.properties.manifest);
      }
      function handleFileLoad(evt, comp) {
      	var images=comp.getImages();	
      	if (evt && (evt.item.type == "image")) { images[evt.item.id] = evt.result; }	
      }
      function handleComplete(evt,comp) {
      	//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
      	var lib=comp.getLibrary();
      	var ss=comp.getSpriteSheet();
      	var queue = evt.target;
      	var ssMetadata = lib.ssMetadata;
      	for(i=0; i<ssMetadata.length; i++) {
      		ss[ssMetadata[i].name] = new createjs.SpriteSheet( {"images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames} )
      	}
      	exportRoot = new lib.March30OffSale_AudiolabWharfedaleDual_AVR_750x1100px_Html5();
      	stage = new lib.Stage(canvas);
      	stage.enableMouseOver();	
      	//Registers the "tick" event listener.
      	fnStartAnimation = function() {
      		stage.addChild(exportRoot);
      		createjs.Ticker.framerate = lib.properties.fps;
      		createjs.Ticker.addEventListener("tick", stage);
      	}	    
      	//Code to support hidpi screens and responsive scaling.
      	AdobeAn.makeResponsive(true,'both',true,1,[canvas,anim_container,dom_overlay_container]);	
      	AdobeAn.compositionLoaded(lib.properties.id);
      	fnStartAnimation();
      }
      </script>
      <!-- write your code here -->
      </head>
      <body onload="init();" style="margin:0px;">
      	<div id="animation_container" style="background-color:rgba(0, 0, 0, 1.00); width:750px; height:1100px">
      		<canvas id="canvas" width="750" height="1100" style="position: absolute; display: block; background-color:rgba(0, 0, 0, 1.00);"></canvas>
      		<div id="dom_overlay_container" style="pointer-events:none; overflow:hidden; width:750px; height:1100px; position: absolute; left: 0px; top: 0px; display: block;">
      		</div>
      	</div>
      </body>
      </html>
    `;

    desktopHero.srcdoc = desktopIframeContent;
    mobileHero.srcdoc = mobileIframeContent;
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xmas-2022-hero"] && !Shopify.designMode) return;
  try {
    
  
    /*<!--*/

    const desktopHero = document.getElementById('desktop-hero'),
          mobileHero = document.getElementById('mobile-hero');

    const desktopIframeContent = `
      <!DOCTYPE html>
      <!--
      	NOTES:
      	1. All tokens are represented by '$' sign in the template.
      	2. You can write your code only wherever mentioned.
      	3. All occurrences of existing tokens will be replaced by their appropriate values.
      	4. Blank lines will be removed automatically.
      	5. Remove unnecessary comments before creating your template.
      -->
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="authoring-tool" content="Adobe_Animate_CC">
      <title>ChristmasSale_AVRDesktop_1800x800px</title>
      <!-- write your code here -->
      <` + `script src="https://code.createjs.com/1.0.0/createjs.min.js"><` + `/script>
      <` + `script src="${desktopScriptURI}"><` + `/script>
      <` + `script>
      var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;
      function init() {
      	canvas = document.getElementById("canvas");
      	anim_container = document.getElementById("animation_container");
      	dom_overlay_container = document.getElementById("dom_overlay_container");
      	var comp=AdobeAn.getComposition("4BC5E3E0F62CD243A8221FC9AB0DEBB1");
      	var lib=comp.getLibrary();
      	var loader = new createjs.LoadQueue(false);
      	loader.addEventListener("fileload", function(evt){handleFileLoad(evt,comp)});
      	loader.addEventListener("complete", function(evt){handleComplete(evt,comp)});
      	var lib=comp.getLibrary();
      	loader.loadManifest(lib.properties.manifest);
      }
      function handleFileLoad(evt, comp) {
      	var images=comp.getImages();	
      	if (evt && (evt.item.type == "image")) { images[evt.item.id] = evt.result; }	
      }
      function handleComplete(evt,comp) {
      	//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
      	var lib=comp.getLibrary();
      	var ss=comp.getSpriteSheet();
      	var queue = evt.target;
      	var ssMetadata = lib.ssMetadata;
      	for(i=0; i<ssMetadata.length; i++) {
      		ss[ssMetadata[i].name] = new createjs.SpriteSheet( {"images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames} )
      	}
      	exportRoot = new lib.ChristmasSale_AVRDesktop_1800x800px();
      	stage = new lib.Stage(canvas);
      	stage.enableMouseOver();	
      	//Registers the "tick" event listener.
      	fnStartAnimation = function() {
      		stage.addChild(exportRoot);
      		createjs.Ticker.framerate = lib.properties.fps;
      		createjs.Ticker.addEventListener("tick", stage);
      	}	    
      	//Code to support hidpi screens and responsive scaling.
      	AdobeAn.makeResponsive(true,'both',true,1,[canvas,anim_container,dom_overlay_container]);	
      	AdobeAn.compositionLoaded(lib.properties.id);
      	fnStartAnimation();
      }
      <` + `/script>
      <!-- write your code here -->
      </head>
      <body onload="init();" style="margin:0px;">
      	<div id="animation_container" style="background-color:rgba(255, 255, 255, 1.00); width:1800px; height:800px">
      		<canvas id="canvas" width="1800" height="800" style="position: absolute; display: block; background-color:rgba(255, 255, 255, 1.00);"></canvas>
      		<div id="dom_overlay_container" style="pointer-events:none; overflow:hidden; width:1800px; height:800px; position: absolute; left: 0px; top: 0px; display: block;">
      		</div>
      	</div>
      </body>
      </html>
    `;


    const mobileIframeContent = `
      <!DOCTYPE html>
      <!--
      	NOTES:
      	1. All tokens are represented by '$' sign in the template.
      	2. You can write your code only wherever mentioned.
      	3. All occurrences of existing tokens will be replaced by their appropriate values.
      	4. Blank lines will be removed automatically.
      	5. Remove unnecessary comments before creating your template.
      -->
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="authoring-tool" content="Adobe_Animate_CC">
      <title>ChristmasSale_AVRMobile_750x1100px</title>
      <!-- write your code here -->
      <` + `script src="https://code.createjs.com/1.0.0/createjs.min.js"><` + `/script>
      <` + `script src="${mobileScriptURI}"><` + `/script>
      <` + `script>
      var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;
      function init() {
      	canvas = document.getElementById("canvas");
      	anim_container = document.getElementById("animation_container");
      	dom_overlay_container = document.getElementById("dom_overlay_container");
      	var comp=AdobeAn.getComposition("4BC5E3E0F62CD243A8221FC9AB0DEBB1");
      	var lib=comp.getLibrary();
      	var loader = new createjs.LoadQueue(false);
      	loader.addEventListener("fileload", function(evt){handleFileLoad(evt,comp)});
      	loader.addEventListener("complete", function(evt){handleComplete(evt,comp)});
      	var lib=comp.getLibrary();
      	loader.loadManifest(lib.properties.manifest);
      }
      function handleFileLoad(evt, comp) {
      	var images=comp.getImages();	
      	if (evt && (evt.item.type == "image")) { images[evt.item.id] = evt.result; }	
      }
      function handleComplete(evt,comp) {
      	//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
      	var lib=comp.getLibrary();
      	var ss=comp.getSpriteSheet();
      	var queue = evt.target;
      	var ssMetadata = lib.ssMetadata;
      	for(i=0; i<ssMetadata.length; i++) {
      		ss[ssMetadata[i].name] = new createjs.SpriteSheet( {"images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames} )
      	}
      	exportRoot = new lib.ChristmasSale_AVRMobile_750x1100px();
      	stage = new lib.Stage(canvas);
      	stage.enableMouseOver();	
      	//Registers the "tick" event listener.
      	fnStartAnimation = function() {
      		stage.addChild(exportRoot);
      		createjs.Ticker.framerate = lib.properties.fps;
      		createjs.Ticker.addEventListener("tick", stage);
      	}	    
      	//Code to support hidpi screens and responsive scaling.
      	AdobeAn.makeResponsive(true,'both',true,1,[canvas,anim_container,dom_overlay_container]);	
      	AdobeAn.compositionLoaded(lib.properties.id);
      	fnStartAnimation();
      }
      <` + `/script>
      <!-- write your code here -->
      </head>
      <body onload="init();" style="margin:0px;">
      	<div id="animation_container" style="background-color:rgba(255, 255, 255, 1.00); width:750px; height:1100px">
      		<canvas id="canvas" width="750" height="1100" style="position: absolute; display: block; background-color:rgba(255, 255, 255, 1.00);"></canvas>
      		<div id="dom_overlay_container" style="pointer-events:none; overflow:hidden; width:750px; height:1100px; position: absolute; left: 0px; top: 0px; display: block;">
      		</div>
      	</div>
      </body>
      </html>
    `;
  

    desktopHero.srcdoc = desktopIframeContent;
    mobileHero.srcdoc = mobileIframeContent;

    /*-->*/
  

  } catch(e) { console.error(e); }
})();
})();
